import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { LoginMessage } from '@model';

@Component({
    selector: 'app-login-message',
    templateUrl: './login-message.component.html',
    standalone: false
})
export class LoginMessageComponent implements OnInit {
  @Input() 
  loginMessage: LoginMessage;

  constructor() {}

  ngOnInit() {

  }

}
